import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { LoginDemoComponent } from './login/logindemo.component';
import { EnetassessComponent } from './enetassess/enetassess.component';
import { LoadexamComponent } from './loadexam/loadexam.component';
import { QuestionsComponent } from './questions/questions.component';
import { FeedbackComponent } from './feedback/feedback.component';
import { MediaComponent } from './media/media.component';
import { ResumeexamComponent } from './resumeexam/resumeexam.component';
import { HttpClientModule } from '@angular/common/http';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { SyncComponent } from './sync/sync.component';
import { MediaHolderComponent } from './questions/media-holder/media-holder.component';
import { AnswerAreaComponent } from './questions/answer-area/answer-area.component';
import { QuestionAreaComponent } from './questions/question-area/question-area.component';
import { QuestionMenuComponent } from './questions/question-menu/question-menu.component';
import { QuestionButtonsComponent } from './questions/question-buttons/question-buttons.component';
import { FinishAssessmentComponent } from './questions/finish-assessment/finish-assessment.component';
import { TimeWarningComponent } from './questions/time-warning/time-warning.component';
import { KillsheetPopupComponent } from './questions/killsheet-popup/killsheet-popup.component';
import { ProgrammeInformationComponent } from './questions/programme-information/programme-information.component';
import { NgxSpinnerModule } from "ngx-spinner";
import { ResizableModule } from 'angular-resizable-element';
import { EscapeHtmlPipe } from './keep-html-pipe';
import { ImageViewerModule } from 'ng2-image-viewer';
import { CookieService } from 'ngx-cookie-service';
import { DeviceDetectorModule, DeviceDetectorService } from 'ngx-device-detector';
import { Ng4LoadingSpinnerModule } from 'ng4-loading-spinner';
import {TranslateModule, TranslateLoader} from '@ngx-translate/core';
import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {HttpClient} from '@angular/common/http';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import { Multi } from './questions/question-area/question-types/multi/multi';
import { Carrousel } from './questions/question-area/question-types/carrousel/carrousel';
import { CarrouselOral } from './questions/question-area/question-types/carrouseloral/carrouseloral';
import { Contextual } from './questions/question-area/question-types/contextual/contextual';
import { DragDrop } from './questions/question-area/question-types/dragdrop/dragdrop';
import { Email } from './questions/question-area/question-types/email/email';
import { Essay } from './questions/question-area/question-types/essay/essay';
import { FIB } from './questions/question-area/question-types/fib/fib';
import { Highlight } from './questions/question-area/question-types/highlight/highlight';
import { ImageMap } from './questions/question-area/question-types/imagemap/imagemap';
import { Matching } from './questions/question-area/question-types/matching/matching';
import { Matrix } from './questions/question-area/question-types/matrix/matrix';
import { MatrixNote } from './questions/question-area/question-types/matrixnote/matrixnote';
import { MatrixSingle } from './questions/question-area/question-types/matrixsingle/matrixsingle';
import {MMFIB} from './questions/question-area/question-types/mmfib/mmfib';
import { Oral } from './questions/question-area/question-types/oral/oral';
import { Tab } from './questions/question-area/question-types/tab/tab';
import { CKEditorModule } from 'ckeditor4-angular';
import { AudioRecorderComponent } from './questions/question-area/question-types/oral/recorder/audio-recorder/audio-recorder.component';
import { EproctorComponent } from './questions/eproctor/eproctor.component';
import { QuestionPreviewComponent } from './questionpreview/questionpreview';
import { AssessmentCompleteComponent } from './assessment-complete/assessment-complete.component';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient);
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    LoginDemoComponent,
    EnetassessComponent,
    LoadexamComponent,
    QuestionsComponent,
    FeedbackComponent,
    MediaComponent,
    ResumeexamComponent,
    SyncComponent,
    MediaHolderComponent,
    AnswerAreaComponent,
    QuestionAreaComponent,
    QuestionMenuComponent,
    QuestionButtonsComponent,
    FinishAssessmentComponent,
    TimeWarningComponent,
    KillsheetPopupComponent,
    ProgrammeInformationComponent,
    EscapeHtmlPipe,
    Carrousel,
    CarrouselOral,
    Contextual,
    DragDrop,
    Email,
    Essay,
    FIB,
    Highlight,
    ImageMap,
    Matching,
    Matrix,
    MatrixNote,
    MatrixSingle,
    MMFIB,
    Multi,
    Oral,
    Tab,
    AudioRecorderComponent,
    EproctorComponent,
    QuestionPreviewComponent,
    AssessmentCompleteComponent
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    NgxImageZoomModule.forRoot(),
    NgxSpinnerModule,
    ResizableModule,
    ImageViewerModule,
    DeviceDetectorModule.forRoot(),
    Ng4LoadingSpinnerModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    CKEditorModule,
  ],
  providers: [
    CookieService,
    DeviceDetectorService
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
